"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import makeStyles from "../../theming/make-styles.js";
import isElement from "../utils/is-element.js";
const useStyles = makeStyles()((theme, { collapsed, color, open }, classes) => {
    const palette = theme.palette(color).menu;
    return {
        label: Object.assign(Object.assign({}, theme.typography.small), { paddingLeft: theme.spacing("md"), marginBottom: theme.spacing("xs"), fontWeight: theme.typography.fontWeights.semiBold, textAlign: "left", color: palette.label.color, [`.${classes.menu} + .${classes.menu} &`]: {
                marginTop: theme.spacing("xs"),
            } }),
        menu: {
            width: collapsed ? "max-content" : undefined,
            paddingLeft: 0,
            margin: 0,
            fontSize: theme.typography.body.fontSize,
            listStyle: "none",
            overflow: "hidden",
            [`.${classes.menu} &`]: {
                display: !collapsed && open ? "inherit" : "none",
            },
        },
    };
});
export const MenuContext = React.createContext({
    alignItems: "center",
    color: "primary",
    openState: [undefined, () => { }],
});
export const Menu = React.forwardRef(function Menu(_a, ref) {
    var { alignItems = "center", children, className, collapsed = false, color = "primary", indentLevel = 0, label, open = false, onClose } = _a, props = __rest(_a, ["alignItems", "children", "className", "collapsed", "color", "indentLevel", "label", "open", "onClose"]);
    const { classes, cx } = useStyles({ collapsed: collapsed, color, open });
    const openState = useState();
    return (_jsx("ul", Object.assign({ ref: ref, className: cx(classes.menu, className), "data-component": "menu", role: "tree" }, props, { children: _jsxs(MenuContext.Provider, { value: { alignItems, color, openState, onMenuClose: onClose }, children: [isElement(label)
                    ? React.cloneElement(label, {
                        className: cx(classes.label, label.props.className),
                    })
                    : label && _jsx("li", { className: classes.label, children: label }), React.Children.map(children, (child) => !!child && React.cloneElement(child, Object.assign({ collapsed, indentLevel: indentLevel + 1 }, child.props)))] }) })));
});
export default Menu;
//# sourceMappingURL=menu.js.map